import getOgmaSupportedLanguageTag from './getOgmaSupportedLanguageTag';
import isLanguageSupported from './isLanguageSupported';

export default function checkCanTranslate(
    toLanguageTag: string,
    fromLanguageTag: string = null
): boolean {
    const toLanguageTagAndScriptInOgma = getOgmaSupportedLanguageTag(toLanguageTag);

    if (!isLanguageSupported(toLanguageTagAndScriptInOgma)) {
        return false;
    }

    // When this function is called with only "toLanguage",
    // we check only if "toLanguage" is supported by Ogma.
    // When this funtion is called with both from and to languages,
    // we check if text from "fromLanguage" can be translated to "toLanguage"
    // So, if "fromLanguage" is null we return true if "toLanguage" is supported.
    if (fromLanguageTag != null) {
        const fromLanguageTagAndScriptInOgma = getOgmaSupportedLanguageTag(fromLanguageTag);

        if (!isLanguageSupported(fromLanguageTagAndScriptInOgma)) {
            return false;
        }

        return toLanguageTagAndScriptInOgma !== fromLanguageTagAndScriptInOgma;
    }

    return true;
}
